import React, { useState, useEffect } from 'react';
import Button from '../../../../CommonComponents/BootstrapComponents/Button/Button';
import { connect } from 'react-redux';
import SideBarPopup from '../../../components/SideBarPopup/SideBarPopup';
import SelectReturnStore from './SelectReturnStore';
import sessionStorageHelper from '../../../../utils/sessionStorageHelper';
import ShippingAddress from '../../Checkout/ShippingAddress/ShippingAddress';
import {
  saveUserAddress,
  getReturnModes,
  getStoreList,
} from '../../../../actionCreators/returnExchange';

import './ReturnMethod.scss';
import { disableBackgroundScroll, enableBackgroundScroll } from '../../../../utils/helper';
import './CommonStyles.scss';
import ReturnAddress from './ReturnAddress';

function ReturnMethod(props) {
  const {
    placeholder,
    modes,
    loadingNearByStore,
    dataLocale,
    returnOrderId,
    orderDetails,
    userAddress,
    saveUserAddress,
    setFifthStep,
    getStoreList,
    setFinalStep,
    setFourthStep,
    setReturnMode,
    updateMethods,
    returnModes,
    getReturnModes,
    storeList,
    setIsExpandable,
    nearByAddress,
    setNearByAddress,
    setThirdStep,
    allModesDisable,
  } = props;
  const {
    VISIT_NEARBY_STORE,
    RETURN_MODE,
    EXCHANGE_OR_REFUND,
    PICKUP_SCHEDULED,
    SHIP_PRODUCT_TO_LENSKART,
    SELECT_PICKUP_ADDRESS,
    ADD_OR_SELECT_ADDRESS,
    SAVED_ADDRESS,
  } = dataLocale;
  const [selectedAddress, setSelectedAddress] = useState();
  const [valueSelected, setValueSelected] = useState('');
  const [storeAddress, setStoreAddress] = useState(false);
  const [isScheduledPickUpPopUpOpen, setIsScheduledPickUpPopUpOpen] = useState(false);
  const shippingAddress =
    orderDetails &&
    orderDetails.result &&
    orderDetails.result.orders &&
    orderDetails.result.orders[0] &&
    orderDetails.result.orders[0].shippingAddress;
  useEffect(() => {
    if (storeAddress) {
      disableBackgroundScroll();
    } else {
      enableBackgroundScroll();
    }
  }, [storeAddress]);

  useEffect(() => {
    if (userAddress && userAddress.postcode) {
      getReturnModes(userAddress?.postcode);
      getStoreList(userAddress?.postcode);
    }
  }, [userAddress]);

  useEffect(() => {
    if (returnModes && storeList && storeList.stores && storeList.stores.length) {
      const storeDetails = storeList.stores[0];
      const { distance } = storeDetails;
      const nearestStoreDistance = distance && distance.humanReadable;
      if (returnModes && returnModes.returnMethods) {
        updateMethods(nearestStoreDistance);
      }
    }
    if (!storeList) {
      updateMethods('');
    }
  }, [storeList, returnModes]);

  useEffect(() => {
    const returnAddress = sessionStorageHelper.getItem('returnUserAddress');
    if (returnAddress) {
      saveUserAddress(returnAddress);
      sessionStorageHelper.setItem('returnUserAddress', returnAddress);
    } else {
      saveUserAddress(shippingAddress);
      sessionStorageHelper.setItem('returnUserAddress', shippingAddress);
    }
  }, [shippingAddress]);

  const handleReturnMode = id => {
    setValueSelected(id);
  };
  const handleContinue = () => {
    let returnStep = sessionStorageHelper.getItem('returnStep') || {};
    let returnAddress = sessionStorageHelper.getItem('returnUserAddress') || {};
    if (valueSelected === 'store_return') {
      setStoreAddress(true);
      setReturnMode(VISIT_NEARBY_STORE);
      setNearByAddress(false);
      returnStep = {
        ...returnStep,
        returnMode: VISIT_NEARBY_STORE,
        returnModeid: valueSelected,
        thirdStep: false,
        setStoreAddress: true,
        isExpandable: RETURN_MODE,
        fourthStep: false,
      };
      setThirdStep(false);
      setFourthStep(false);
    }
    if (valueSelected === 'warehouse_return' || valueSelected === 'schedule_pickup') {
      let address = '';
      const pickupScheduleAddress = returnAddress.postcode ? returnAddress : userAddress;
      if (pickupScheduleAddress) {
        if (pickupScheduleAddress.addressline1) address += `${pickupScheduleAddress.addressline1} `;
        if (pickupScheduleAddress.addressline2) address += `${pickupScheduleAddress.addressline2} `;
        if (pickupScheduleAddress.city) address += `${pickupScheduleAddress.city} `;
        if (pickupScheduleAddress.state) address += `${pickupScheduleAddress.state} `;
        if (pickupScheduleAddress.postcode) address += pickupScheduleAddress.postcode;
      }
      setNearByAddress(address);
      sessionStorageHelper.removeItem('returnStore');
      if (!returnStep.thirdStep) {
        setIsExpandable(EXCHANGE_OR_REFUND);
        setThirdStep(true);
        returnStep = {
          ...returnStep,
          isExpandable: EXCHANGE_OR_REFUND,
        };
        setFinalStep('');
      } else {
        setIsExpandable(returnStep.isExpandable);
      }
      if (valueSelected === 'schedule_pickup') {
        returnAddress = pickupScheduleAddress;
        sessionStorageHelper.setItem('returnUserAddress', returnAddress);
        setReturnMode(PICKUP_SCHEDULED);
        if (!returnStep.thirdStep) {
          returnStep = {
            ...returnStep,
            thirdStep: true,
            returnMode: PICKUP_SCHEDULED,
            isExpandable: EXCHANGE_OR_REFUND,
            returnModeid: valueSelected,
            finalStep: '',
          };
        } else {
          returnStep = {
            ...returnStep,
            returnMode: PICKUP_SCHEDULED,
            returnModeid: valueSelected,
          };
        }
      } else {
        setReturnMode(SHIP_PRODUCT_TO_LENSKART);
        if (!returnStep.thirdStep) {
          returnStep = {
            ...returnStep,
            thirdStep: true,
            returnMode: SHIP_PRODUCT_TO_LENSKART,
            isExpandable: EXCHANGE_OR_REFUND,
            returnModeid: valueSelected,
            finalStep: '',
          };
        } else {
          returnStep = {
            ...returnStep,
            returnMode: SHIP_PRODUCT_TO_LENSKART,
            returnModeid: valueSelected,
          };
        }
      }
    }
    sessionStorageHelper.setItem('returnStep', returnStep);
  };

  const renderContinueBtn = (id, title = 'Continue') => {
    if (valueSelected === id) {
      let productToReturn = sessionStorageHelper.getItem('returnProduct') || {};
      productToReturn = {
        ...productToReturn,
        returnMode: valueSelected,
      };
      sessionStorageHelper.setItem('returnProduct', productToReturn);
      return (
        <div className="justify-content-end display-flex margin-t10">
          <Button
            className="text-color-white bg-color-primary fs14 fw500 text-uppercase"
            style={{ padding: '5px 40px' }}
            onClick={handleContinue}
          >
            {title}
          </Button>
        </div>
      );
    }
  };
  return (
    <div>
      <div className="margin-l20 padding-9">
        {placeholder ? (
          <div>
            <img alt="rm" aria-label="PlaceHolder Icon" src={placeholder} />
          </div>
        ) : (
          <>
            {userAddress ? (
              <div className="pickup-address-wrapper">
                <ReturnAddress
                  changeAddress={() => setIsScheduledPickUpPopUpOpen(true)}
                  pickupLabel={`${userAddress.firstName ? userAddress.firstName : ''} ${
                    userAddress.lastName ? userAddress.lastName : ''
                  }`}
                  userAddress={userAddress}
                />
              </div>
            ) : (
              ''
            )}
            {modes &&
              modes.map((mode, i) => {
                const disable = Boolean(mode.error && mode.error.status === false ? 0 : 1);
                return (
                  <div key={mode.id} className={`${i + 1 === modes.length ? '' : 'border-bottom'}`}>
                    <div
                      key={mode.id}
                      className={`${disable ? 'text-color-grey' : ''}`}
                      style={{ display: 'flex', alignItems: 'center' }}
                    >
                      <input
                        checked={valueSelected === mode.id}
                        disabled={disable}
                        name="return-mode"
                        type="radio"
                        value={mode.id}
                        onChange={() => handleReturnMode(mode.id)}
                      />
                      {mode.src && (
                        <img
                          alt="return-mode"
                          className={`margin-8 margin-l25 ${disable ? 'filter' : ''}`}
                          src={mode.src}
                          style={{ cursor: disable ? 'no-drop' : 'pointer' }}
                          width="5%"
                          onClick={disable ? '' : () => handleReturnMode(mode.id)}
                        />
                      )}
                      <div
                        className="margin-t15 width100"
                        style={{ cursor: disable ? 'no-drop' : 'pointer' }}
                        onClick={disable ? '' : () => handleReturnMode(mode.id)}
                      >
                        <span className="margin-l40 fw600 fs14">{mode.title}</span>
                        {mode.badge && (
                          <span className="return-badge margin-l15">{mode.badge}</span>
                        )}
                        {mode.subText && mode.subText.contents && !disable && (
                          <ul>
                            {mode.subText.contents.map(content => (
                              <li
                                key={content}
                                className="margin-l40 fs12 text-color-grey"
                                dangerouslySetInnerHTML={{ __html: content }}
                              />
                            ))}
                          </ul>
                        )}
                        {!allModesDisable && mode.error && (
                          <div className="error margin-b9">
                            {mode.error.status && (
                              <div className="display-flex align-items-center mr-t8 margin-l38 margin-t1">
                                <span
                                  className={` ${
                                    disable ? 'text-red' : 'text-color_dull_black'
                                  } fsp11 mr-l8 lh-14 fs12`}
                                  dangerouslySetInnerHTML={{ __html: mode.error.text }}
                                ></span>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                      {renderContinueBtn(mode.id)}
                    </div>
                  </div>
                );
              })}
          </>
        )}
      </div>
      {storeAddress && (
        <SideBarPopup
          dialogClassName="power-type-modal"
          open={storeAddress}
          onClose={setStoreAddress}
        >
          <SelectReturnStore
            dataLocale={dataLocale}
            loadingNearByStore={loadingNearByStore}
            nearByAddress={nearByAddress}
            returnOrderId={returnOrderId}
            setFifthStep={setFifthStep}
            setFinalStep={setFinalStep}
            setIsExpandable={setIsExpandable}
            setNearByAddress={setNearByAddress}
            userAddress={userAddress}
          />
        </SideBarPopup>
      )}
      {isScheduledPickUpPopUpOpen && (
        <SideBarPopup
          dialogClassName="power-type-modal"
          open={isScheduledPickUpPopUpOpen}
          onClose={setIsScheduledPickUpPopUpOpen}
        >
          <div style={{ margin: '36px' }}>
            <div className="fs20 fw500">{SELECT_PICKUP_ADDRESS}</div>
            <div className="fs14 fw400 color-lightgrey">{ADD_OR_SELECT_ADDRESS}</div>
            <div className="fs14 bold margin-t22 color-lightgrey">{SAVED_ADDRESS}</div>
            <ShippingAddress
              isReturnExchange
              ReturnExchange_onSubmitAddress={address => {
                saveUserAddress(address);
                let returnAddress = sessionStorageHelper.getItem('returnUserAddress') || {};
                returnAddress = { ...address };
                sessionStorageHelper.setItem('returnUserAddress', returnAddress);
              }}
              defaultUserAddress={userAddress}
              selectedAddress={selectedAddress}
              setIsScheduledPickUpPopUpOpen={val => setIsScheduledPickUpPopUpOpen(val)}
              setSelectedAddress={setSelectedAddress}
            />
          </div>
        </SideBarPopup>
      )}
    </div>
  );
}

const mapStateToProps = state => {
  return {
    orderDetails: state.order.orderDetails,
    userAddress: state.returnExchange.userAddress,
    returnModes: state.returnExchange.returnModes,
    storeList: state.returnExchange.nearbyStore && state.returnExchange.nearbyStore.result,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    saveUserAddress: address => dispatch(saveUserAddress(address)),
    getReturnModes: pincode => dispatch(getReturnModes(pincode)),
    getStoreList: postcode => dispatch(getStoreList(postcode)),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(ReturnMethod);
